/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

const scope = 'parousya-saas-web/App';

// API fetch
export const FETCH_START = `${scope}/FETCH_START`;
export const FETCH_END = `${scope}/FETCH_END`;
export const FETCH_ERROR = `${scope}/FETCH_ERROR`;
export const FETCH_CANCEL = `${scope}/FETCH_CANCEL`;

// Auth
export const USER_LOGIN = `${scope}/USER_LOGIN`;
export const USER_LOGIN_ERROR = `${scope}/USER_LOGIN_ERROR`;
export const USER_LOGIN_SUCCESS = `${scope}/USER_LOGIN_SUCCESS`;
export const USER_CHECK = `${scope}/USER_CHECK`;
export const USER_LOGOUT = `${scope}/USER_LOGOUT`;

// User profile
export const LOAD_USER = `${scope}/LOAD_USER`;
export const LOAD_USER_ERROR = `${scope}/LOAD_USER_ERROR`;
export const LOAD_USER_SUCCESS = `${scope}/LOAD_USER_SUCCESS`;
export const LOAD_USER_CANCELLED = `${scope}/LOAD_USER_CANCELLED`;

// Sidebar
export const SIDEBAR_VISIBILITY_TOGGLE = `${scope}/SIDEBAR_VISIBILITY_TOGGLE`;
export const SIDEBAR_VISIBILITY_SHOW = `${scope}/SIDEBAR_VISIBILITY_SHOW`;
export const SIDEBAR_VISIBILITY_HIDE = `${scope}/SIDEBAR_VISIBILITY_HIDE`;
export const SIDEBAR_STICKY_TOGGLE = `${scope}/SIDEBAR_STICKY_TOGGLE`;
export const SIDEBAR_STICKY_ENABLE = `${scope}/SIDEBAR_STICKY_ENABLE`;
export const SIDEBAR_STICKY_DISABLE = `${scope}/SIDEBAR_STICKY_DISABLE`;

// Layout
export const LAYOUT_BOXED_TOGGLE = `${scope}/LAYOUT_BOXED_TOGGLE`;
export const LAYOUT_BOXED_ENABLE = `${scope}/LAYOUT_BOXED_ENABLE`;
export const LAYOUT_BOXED_DISABLE = `${scope}/LAYOUT_BOXED_DISABLE`;

// Theme
export const THEME_TOGGLE = `${scope}/THEME_TOGGLE`;

export const CANCEL_CURRENT_PLAN = `${scope}/CANCEL_CURRENT_PLAN`;

// User roles
export const ROLE_SUPERADMIN = 'superadmin';
export const ROLE_ADMIN = 'admin';
export const ROLE_USER = 'user';
